import { ArrowLeftIcon, EyeIcon, HandPointingIcon, TrashIcon } from '@phosphor-icons/react';
import { DatePicker } from '@/components/date-picker';
import { Button } from '@/components/ui/button';
import { createFileRoute, Link, redirect } from '@tanstack/react-router';
import { FunnelReport } from '@/components/reports/funnel-report';
import { StepModal } from '@/components/reports/step-modal';
import { SaveReportModal } from '@/components/reports/save-report-modal';
import { useSteps } from '@/hooks/use-steps';
import { PageHeader } from '@/components/page-header';
import { PageContent } from '@/components/page-content';
import { hasPermission } from '@/lib/permissions';
import type { FunnelReportConfig } from '@/types';

export const Route = createFileRoute(
  '/_auth/_side-layout/funnels_/add-funnel-report',
)({
  component: ReportsFunnels,
  beforeLoad: async ({ context }) => {
    if (!hasPermission(context.userRole, { project: ['update'] })) {
      throw redirect({ to: '/funnels' });
    }
  },
});

function ReportsFunnels() {
  const { steps, removeStep, clearSteps } = useSteps();
  const config: FunnelReportConfig = { type: 'funnel', steps };

  return (
    <>
      <PageHeader title="Add Funnel Report" description="Define the steps in your conversion funnel." />
      <PageContent>
        <div className="flex items-center gap-3">
          <Link to={'/funnels' as string}>
            <Button iconLeft={<ArrowLeftIcon />} variant="outline">
              Back
            </Button>
          </Link>
          <DatePicker />
          {steps.length > 0 && (
            <Button variant="outline" onClick={() => clearSteps()}>
              Reset
            </Button>
          )}
          {steps.length > 0 && <SaveReportModal config={config} />}
        </div>

        <div className="flex w-full items-center gap-5 rounded border border-border p-5 transition-all">
          {steps.map((step) => (
            <div key={step.value}>
              <div className="flex items-center gap-10 rounded border border-border px-5 py-3 hover:border-primary hover:text-primary">
                <div className="flex items-center gap-2">
                  {step.type === 'Pageview' ? (
                    <EyeIcon className="text-primary" />
                  ) : (
                    <HandPointingIcon className="text-primary" />
                  )}
                  <span className="font-bold">{step.value}</span>
                </div>
                <span className="cursor-pointer" onClick={() => removeStep(step)}>
                  <TrashIcon />
                </span>
              </div>
            </div>
          ))}
          {steps?.length <= 2 && <StepModal />}
        </div>
        <FunnelReport config={config} />
      </PageContent>
    </>
  );
}
